<template>
  <div class="create-or-edit-calendar-event-wrapper" v-bind:class="{loaded: !loading}">
    <create-or-edit-component v-if="!loading"
                              :attachable-type="instanceType"
                              :attachable-key="instanceId"
                              :customer-id="customerId"
                              :event="event"
                              @close="redirectBack"
                              @updated="redirect"></create-or-edit-component>
  </div>
</template>

<script>
import CreateOrEditComponent from './CreateOrEditComponent.vue'
import calendarEventApi from '~/api/calendar_event'

export default {
  components: { CreateOrEditComponent },
  name: 'CalendarEventCreateOrEditBladeWrapperComponent',
  props: {
    customerId: {
      type: [String, Number],
      required: false,
    },
    eventId: {
      type: [String, Number],
      required: false,
    },
    instanceType: {
      type: String,
      required: false,
    },
    instanceId: {
      type: [String, Number],
      required: false,
    },
    referrer: {
      type: String,
      required: false,
    }
  },
  data () {
    return {
      event: null,
      loading: true,
    }
  },
  created () {
    if (this.eventId) {
      calendarEventApi.find(this.eventId, 'customer').then((response) => {
        this.event = response.data
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om de afspraak te laden',
        })
      }).finally(() => {
        this.loading = false
      })
    } else {
      this.loading = false
    }
  },
  methods: {
    redirect () {
      if (this.referrer) {
        window.location.href = this.referrer
      } else {
        window.location.href = '/customer/' + this.customerId + '/dashboard'
      }
    },
    redirectBack () {
      window.history.back()
    }
  }
}
</script>

<style scoped>
.create-or-edit-calendar-event-wrapper {
  max-width: 600px;
}
</style>